import { SVGProps } from 'react';

const SvgWarning = (props: SVGProps<SVGSVGElement>) => (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" {...props}>
        <path d="M.667 14h14.666L8 1.333.667 14Zm2.313-1.333L8 3.993l5.02 8.674H2.98Zm4.353-2h1.334V12H7.333v-1.333Zm0-4h1.334v2.666H7.333V6.667Z" />
    </svg>
);
export default SvgWarning;
